<div class="article-banner" *ngIf="article?.banner">
	<app-image [natural]="false" [url]="article.banner"></app-image>
</div>
<div class="gutter">
	<div class="article flx-col" *ngIf="article">
		<h1 class="gutter-v-half">{{ article?.name }}</h1>
		<app-ve *ngIf="article" [content]="article.content" [module]="'articles'" [dir]="article.photos_directory" (changed)="changeModel($event)"></app-ve>
	</div>
	<div class="article article-info flx-row flx-btwn-cntr flx-gap-default" *ngIf="article">
		<a class="icon-link" [routerLink]="['/'+path_list]">
			<span i18n>wróć do listy</span>
		</a>
		<div class="flx-row flx-btwn-cntr flx-gap-default">
			<a class="icon-link" *ngIf="article.prev" [routerLink]="['/'+path_details, article.prev]">
				<span i18n>poprzedni wpis</span>
			</a>
			<a class="icon-link" *ngIf="article.next" [routerLink]="['/'+path_details, article.next]">
				<span i18n>następny wpis</span>
			</a>
		</div>
	</div>
</div>